import React, { useEffect, useState } from "react";
import "./style.css";
import ProgressBar from "./ProgressBar";
import StarIcon from "@mui/icons-material/Star";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import ImgReview from "../../assets/images/review_user.jpg";
import { baseURL } from "../../constants/url";

const ProductsListReview = ({ productId }) => {
  const [reviews, setReviews] = useState([]);
  const [reviewCount, setReviewCount] = useState(0);
  const [averageRating, setAverageRating] = useState(0);

  useEffect(() => {
     const fetchReviews = async () => {
        try {
          const token = localStorage.getItem("authToken");

          const res = await fetch(`${baseURL}common/ratings/`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (!res.ok) {
            throw new Error("Unauthorized or failed to fetch reviews.");
          }

          const data = await res.json();

          if (Array.isArray(data)) {
            // ✅ Updated filter line
            const filteredReviews = data.filter(
              (review) => Number(review.variant_id) === Number(productId)
            );

            setReviews(filteredReviews);
            setReviewCount(filteredReviews.length);

            const total = filteredReviews.reduce((acc, curr) => acc + curr.rating, 0);
            const avg = filteredReviews.length ? total / filteredReviews.length : 0;
            setAverageRating(avg.toFixed(1));
          } else {
            console.error("Unexpected response format:", data);
          }
        } catch (error) {
          console.error("Error fetching reviews:", error);
        }
      };


    if (productId) {
      fetchReviews();
    }
  }, [productId]);

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 !== 0;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

    return (
      <>
        {[...Array(fullStars)].map((_, i) => (
          <StarIcon key={`full-${i}`} />
        ))}
        {halfStar && <StarHalfIcon />}
        {[...Array(emptyStars)].map((_, i) => (
          <StarOutlineIcon key={`empty-${i}`} />
        ))}
      </>
    );
  };

  return (
    <div className="products_list_review_box">
      <div className="products_list_review_box_in">
        <div className="review-section">
          <div className="qa-box">
            <h5 className="common_color">
              Customer questions  & answers ({reviewCount} Review{reviewCount !== 1 ? "s" : ""})
            </h5>
            {reviews.length === 0 ? (
              <p>No reviews available for this product.</p>
            ) : (
              reviews.map((review) => (
                <div key={review.id} className="qa-card mb_20">
                  <img
                    className="reviewer_user"
                    src={review.images?.[0]?.image || ImgReview}
                    alt="User"
                  />
                  <div className="qa-content">
                    <div className="qa-meta">
                      {new Date(review.created_at).toLocaleString()}
                    </div>
                    <div className="qa-message">
                      <p className="common_text">{review.review}</p>
                    </div>
                    <div className="stars">{renderStars(review.rating)}</div>
                    <div className="qa-footer">
                      {review.user_first_name} · <span>{review.user_last_name}</span>
                    </div>
                  </div> 
                </div>
              ))
            )}
          </div>

          <div className="summary-box">
            <h5 className="common_color">Customer reviews</h5>
            <div className="summary-header">
              <div className="stars">{renderStars(averageRating)}</div>
              <div className="rating-text">{averageRating} out of 5</div>
            </div>

            <div className="progress_bar">
              <ProgressBar bgcolor="#28a745" progress="100" height={22} />
              <ProgressBar bgcolor="#28a745" progress="80" height={22} />
              <ProgressBar bgcolor="#28a745" progress="60" height={22} />
              <ProgressBar bgcolor="#28a745" progress="40" height={22} />
              <ProgressBar bgcolor="#28a745" progress="20" height={22} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsListReview;
